import type { TotpSetupActivationTarget } from '@pillar-portal/api-types';

export function buildRequiredTotpSetupPath(target: TotpSetupActivationTarget | undefined): string {
    const nextSearchParams = new URLSearchParams();
    if (target?.role_assignment_uuid !== undefined) {
        nextSearchParams.set('required_role_assignment_uuid', target.role_assignment_uuid);
    }
    if (target?.organization_uuid !== null && target?.organization_uuid !== undefined) {
        nextSearchParams.set('required_organization_uuid', target.organization_uuid);
    }
    if (target?.organization_name !== null && target?.organization_name !== undefined) {
        nextSearchParams.set('required_organization_name', target.organization_name);
    }
    return nextSearchParams.toString().length > 0
        ? `/login/mfa-setup?${nextSearchParams.toString()}`
        : '/login/mfa-setup';
}
